import { FC } from 'react';
import cx from 'classnames';
import styles from './HeaderEquipmentSeparator.module.scss';

export const HeaderEquipmentSeparator: FC<{
  isFeatureFlag?: boolean;
  size?: string;
}> = ({ isFeatureFlag, size }) => {
  return (
    <div
      slot="custom"
      className={cx(styles['separator'], {
        [styles['separator__isheader']]: isFeatureFlag && size == 'md',
        [styles['separator__isbanner']]: isFeatureFlag && size == 'lg'
      })}
    />
  );
};
